import { tokens } from '@fluentui/react-components';

export const DASHBOARD_CARD_APPEARANCE_STYLE = {
  borderRadius: tokens.borderRadiusMedium,
  border: `1px solid ${tokens.colorNeutralStroke2}`,
  boxShadow: tokens.shadow2,
  backgroundColor: tokens.colorNeutralBackground1,
};
